import {useState} from "@wordpress/element";
import {useDispatch} from "@wordpress/data";
const {cartStore} = window.wc.wcBlocksData;

export default function Coupon( {coupon} ){

	const [loading, setLoading] = useState(false);

	const { removeCoupon, invalidateResolutionForStore } = useDispatch(cartStore);

	const handleRemoveCoupon = async () => {
		setLoading(true);
		try{
			await removeCoupon(coupon.code);
		} catch(error){
			// Force a cart refresh.
			invalidateResolutionForStore();
		} finally {
			setLoading(false);
		}
	}

	// Adjust coupon names for Cashier.
	let coupon_code = coupon.code;
	const match = coupon_code.match(/zap_cashier_\d+_([a-zA-Z0-9]+)/);

	if ( match ) {

		// Default label.
		coupon_code = "Cashier Discount";

		// Get account label from coupon code.
		const key = match[1];
		if( window.ZapCashierCheckout.cashier_account_labels && window.ZapCashierCheckout.cashier_account_labels[key] ){
			coupon_code = window.ZapCashierCheckout.cashier_account_labels[key];
		}
	}

	return (
		<div className="zapc-checkout-coupon">
			<span className="zapc-checkout-coupon-code">{coupon_code}</span>
			<span className="zapc-checkout-coupon-amount">-{ coupon.totals.currency_prefix + ( coupon.totals.total_discount / 100).toFixed(2)}</span>
			<button className="zapc-checkout-coupon-remove" onClick={handleRemoveCoupon}>
				{ !loading && <i className="fa fa-times"></i> }
				{ loading && <i className="fa fa-spinner fa-spin"></i> }
			</button>
		</div>
	);
}